module.exports = __webpack_public_path__ + "static/img/GettyImages-580501693.70a1c18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-580501693.jpg
// module id = gyvE
// module chunks = 0